import { Status } from 'civic-champs-shared/api/hooks'
import useFetchRefactored from 'civic-champs-shared/api/hooks/useFetchRefactored'
import { useCallback } from 'react'
import { OpportunityTemplateCredential } from 'volunteering/opportunities/interfaces'
import { useCurrentOrg } from 'civic-champs-shared/auth/hooks'

export const useGetOpportunityTemplateCredentials = (): [
  (opportunityId: number) => Promise<OpportunityTemplateCredential[]>,
  Status<OpportunityTemplateCredential[]>,
] => {
  const org = useCurrentOrg()
  const [request, status] = useFetchRefactored<OpportunityTemplateCredential[]>({
    errorMessage: 'Error Fetching Template Credentials',
    emptyValue: [],
  })

  const fetchOpportunityTemplateGroups = useCallback(
    (opportunityId: number) => {
      return request({
        method: 'get',
        url: `/organizations/${org.id}/opportunity_templates/${opportunityId}/credentials`,
      })
    },
    [org.id, request],
  )

  return [fetchOpportunityTemplateGroups, status]
}

export default useGetOpportunityTemplateCredentials
